require('../modules/web.dom.iterable');
require('../modules/es6.string.iterator');
module.exports = require('../modules/core.is-iterable');


//////////////////
// WEBPACK FOOTER
// ./~/.2.4.1@core-js/library/fn/is-iterable.js
// module id = 511
// module chunks = 0 1